import { showGameModeInfoDialog } from '../../../../shared/scripts/ui_popup/showGameModeInfoDialog.ts';
import { GameModeDataController } from '@colonist/shared-types';
import { ClientUserState } from '../../../../shared/scripts/ClientUserState.ts';
import { UIComponentItemScroll } from '../../../../shared/scripts/ui_components/item_scroll/UIComponentItemScroll.ts';
import { ModeSettingEnum } from '@colonist/game-base-types';
import { socket } from '../../../../shared/scripts/EntryShared.ts';
export class UIRoomCenterSettingsModeController {
    update(newRoomState) {
        const shouldUpdate = this.shouldUpdate(newRoomState);
        this.roomState = newRoomState;
        if (shouldUpdate) this.updateModeSelector();
    }
    load(roomState) {
        this.roomState = roomState;
        if (this.modeSelector == undefined) {
            this.createModeSelector();
            return;
        }
        this.updateModeSelector();
    }
    updateInteractabilityOfElements(isGuest) {
        this.modeSelector.updateInteractabilityOfElements(isGuest);
    }
    createModeSelector() {
        const gameModeItemData = this.getModeItemData();
        this.modeSelector = new UIComponentItemScroll(this.modeSelectionDiv, gameModeItemData);
    }
    updateModeSelector() {
        const gameModeItemData = this.getModeItemData();
        this.modeSelector.update(gameModeItemData);
    }
    getModeItemData() {
        const allGameModeData = GameModeDataController.publicGameModeDataList;
        const userState = ClientUserState.userState;
        const gameModeItemData = [];
        for (const gameModeData of allGameModeData){
            if (gameModeData.modeSetting == ModeSettingEnum.ServerStressTestClassic4P) continue;
            const isGameModeAvailable = this.isGameModeAvailable(gameModeData, userState);
            const isGameModeSelected = this.isGameModeSelected(gameModeData);
            const clickAction = ()=>{
                socket.roomClient.setGameMode(gameModeData.modeSetting);
            };
            const displayInfoAction = ()=>{
                showGameModeInfoDialog(gameModeData);
            };
            const itemData = {
                name: UIRoomCenterSettingsModeController.getGameModeName(gameModeData),
                image: gameModeData.icon,
                available: isGameModeAvailable,
                selected: isGameModeSelected,
                clickAction: clickAction,
                infoAction: displayInfoAction,
                showInfoIcon: true
            };
            gameModeItemData.push(itemData);
        }
        return gameModeItemData;
    }
    isGameModeAvailable(gameModeData, userState) {
        if (this.roomState.isTestFreeExpansionsAndMaps) return true;
        if (this.roomState.isTournament) return true;
        if (gameModeData.isGameModePremium() == false) return true;
        if (userState === null || userState === void 0 ? void 0 : userState.items.hasAccessToPremiumMode(gameModeData)) return true;
        return false;
    }
    isGameModeSelected(gameModeData) {
        return gameModeData.modeSetting == this.roomState.gameSetting.modeSetting;
    }
    shouldUpdate(newRoomState) {
        const didModeChange = this.roomState.gameSetting.modeSetting != newRoomState.gameSetting.modeSetting;
        if (didModeChange) return true;
        return false;
    }
    static getGameModeName(gameModeData) {
        switch(gameModeData.modeSetting){
            case ModeSettingEnum.Classic56P:
                return {
                    key: 'strings:colonistCommon.gameModes.classic56P.abbreviation'
                };
            case ModeSettingEnum.Classic78P:
                return {
                    key: 'strings:colonistCommon.gameModes.classic78P.abbreviation'
                };
            case ModeSettingEnum.Seafarers56P:
                return {
                    key: 'strings:colonistCommon.gameModes.seafarers56P.abbreviation'
                };
            case ModeSettingEnum.CitiesAndKnights56P:
                return {
                    key: 'strings:colonistCommon.gameModes.citiesAndKnights56P.abbreviation'
                };
            case ModeSettingEnum.CitiesAndKnightsSeafarers4P:
                return {
                    key: 'strings:colonistCommon.gameModes.seafarersAndCitiesAndKnights4P.abbreviation'
                };
            case ModeSettingEnum.CitiesAndKnightsSeafarers56P:
                return {
                    key: 'strings:colonistCommon.gameModes.seafarersAndCitiesAndKnights56P.abbreviation'
                };
            default:
                return gameModeData.name;
        }
    }
    constructor(){
        this.modeSelectionDiv = document.getElementById('room_center_game_mode_settings');
    }
}
